export class MvsFormValueListEntryDto {

    public key?: any;
    public label?: string;
    public technicalKey?: string;
    public image?: string;
    public description?: string;
    public color?: string;
    public backgroundColor?: string;
    public priority?: number;
    public uiClass?: any;

    public parentKey?: any;

    public static createBasic(key: any, label: string): MvsFormValueListEntryDto {
        const entry = new MvsFormValueListEntryDto();
        entry.key = key;
        entry.label = label;
        return entry;
    }

    public setImage?(image: string): MvsFormValueListEntryDto {
        this.image = image;
        return this;
    }

    public setColor?(color: string): MvsFormValueListEntryDto {
        this.color = color;
        return this;
    }

    public setBackgroundColor?(backgroundColor: string): MvsFormValueListEntryDto {
        this.backgroundColor = backgroundColor;
        return this;
    }



}
